import '../../../node_modules/slick-carousel/slick/slick.js';
import './custom.js';
import './tm.js';


jQuery(function ($) {

});
